import axios from "axios";


export const getBusinessAccount = (requestData) => {
    const response = axios.get(process.env.REACT_APP_API_MERCHANT + '/developer-accounts/merchant/' + requestData.userId, {
        headers: {
            "Authorization": `Bearer ${requestData.token}`
        }
    });
    return response;
}

export const getTransactionsOfBusinessAccount = (requestData) => {
    console.log(requestData.businessId);
    const response = axios.get(process.env.REACT_APP_API_TRANSACTION + `/transaction/pay-in/${requestData.businessId}`, {
        headers: {
            "Authorization": `Bearer ${requestData.token}`
        }
    });
    return response;
}

export const getPaymentMethodsByCountry = (requestData) => {
    const response = axios.get(process.env.REACT_APP_API_TRANSACTION +'/payment-method', {
        headers : {
            "Authorization" : `Bearer ${requestData.token}`
        }
    });
    console.log(response)
    return response;
}